(function (ws) {
    'use strict';
    ws.models.quoteTableAvailabilityTooltipModel = ws.models.outstandingStock.extend({

        /**
         * Initialize override to include model options
         * @param {Object} options
         */
        initialize: function(options) {
            this.options = options;
        },

        /**
         * Build URL based on passed Category Selected and Product number
         * @returns {string}
         */
        url: function() {
            if (!_.isUndefined(this.options.quoteId)) {
                this.options.quoteId = '/' + this.options.quoteId;
            } else {
                this.options.quoteId = '';
            }

            if (this.options.itemCategorySelected !== '' || this.options.itemCategorySelected !== null) {
                return globals.path.api.quoting.quoteTableGetAvailabilityByCategory + this.options.itemCategorySelected + this.options.quoteId + '/?productCode=' + this.options.partNo;
            } else {
                return globals.path.api.quoting.quoteTableGetAvailability + this.options.quoteId + '/?productCode=' + this.options.partNo;
            }
        },

        /**
         * Parsing the response data to template
         * @param {Object} data
         * @returns {{sapAvailabilityList: *, futureAvailabilityCount: integer, maxAvailabilityRows: integer}}
         */
        parse: function (data) {
            return {
                sapAvailabilityList: data,
                maxAvailabilityRows: this.getMaxRowCount(data),
                futureAvailabilityCount: this.hasFutureAvailability(data),
                isCustomerInventoryCount: this.hasCustomerStock(data)
            };
        }
    });
})(westcon);
